module.exports = __webpack_public_path__ + "img/t5-14.6a26d2d9.svg";